import * as React from 'react';
import { useSelector } from 'react-redux';
import { IRatingGraphItem } from '../../types/developer/ratings';
import { RatingLegend as RatingLegendComponent } from '../../components/RatingLegend';
import { IApplicationState } from '../../types/redux';
import { getDeveloperRatingLegendById } from '../../selectors';

interface IRatingLegendProps {
  ratingId: number;
}

export function RatingLegend({ ratingId }: IRatingLegendProps) {
  const legends = useSelector((state: IApplicationState) => getDeveloperRatingLegendById(state, ratingId));
  const preparedLegends = React.useMemo(() => getFilledLegend(legends), [legends]);

  return <RatingLegendComponent legends={preparedLegends} />;
}

function getFilledLegend(legends: IRatingGraphItem[]) {
  return legends.reduce((acc, current) => {
    if (!current.legend) {
      return acc;
    }

    return [...acc, { legend: current.legend, color: current.color }];
  }, []);
}
